module.exports = __webpack_public_path__ + "img/2025-11-17c_10.5a843eb2.jpg";